import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../utils/api';
import CropCard from '../../components/crops/CropCard';

export default function MarketplacePage() {
  const location    = useLocation();
  const urlParams   = new URLSearchParams(location.search);
  const [crops, setCrops]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [total, setTotal]       = useState(0);
  const [page, setPage]         = useState(1);
  const [hasMore, setHasMore]   = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [search, setSearch]     = useState('');
  const [showFilters, setShowFilters] = useState(false);

  // Single source of truth for filters
  const [filters, setFilters] = useState({
    category:    urlParams.get('category') || '',
    subCategory: urlParams.get('sub') || '',
    location:    '',
    sort:        'newest',
    minPrice:    '',
    maxPrice:    '',
  });

  // Reload whenever any filter changes
  useEffect(() => { load(1); }, [filters, search]);

  const load = async (p) => {
    if (p === 1) setLoading(true); else setLoadingMore(true);
    try {
      const params = new URLSearchParams({ page:p, limit:10 });
      if (filters.category)    params.set('category',    filters.category);
      if (filters.subCategory) params.set('subCategory', filters.subCategory);
      if (filters.sort)        params.set('sort',        filters.sort);
      if (filters.minPrice)    params.set('minPrice',    filters.minPrice);
      if (filters.maxPrice)    params.set('maxPrice',    filters.maxPrice);
      if (search)              params.set('search',      search);
      const { data } = await api.get('/crops/marketplace?' + params);
      const list = data.crops || [];
      // Client-side location filter
      const filtered = filters.location
        ? list.filter(c =>
            (c.locationAddress||'').toLowerCase().includes(filters.location.toLowerCase()) ||
            (c.userId?.locationAddress||'').toLowerCase().includes(filters.location.toLowerCase()))
        : list;
      if (p === 1) setCrops(filtered); else setCrops(prev => [...prev, ...filtered]);
      setHasMore(list.length === 10);
      setTotal(data.total || 0);
      setPage(p);
    } catch {} finally { setLoading(false); setLoadingMore(false); }
  };

  const setF = (k, v) => setFilters(p => ({
    ...p, [k]: v,
    ...(k === 'category' ? { subCategory:'' } : {})
  }));

  return (
    <div style={{ paddingBottom:90 }}>
      {/* Header */}
      <div className="header">
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <div className="header__title">🛒 Marketplace</div>
            <div className="header__subtitle">{total} crops ready to buy</div>
          </div>
          <div style={{ display:'flex', gap:8 }}>
            <button onClick={() => setF('sort', filters.sort==='newest' ? 'cheapest' : 'newest')}
              style={{ background:'rgba(255,255,255,0.2)', border:'none', borderRadius:20, padding:'5px 12px', color:'white', fontSize:12, cursor:'pointer' }}>
              {filters.sort==='newest' ? '💰 Price' : '🕐 New'}
            </button>
          </div>
        </div>
      </div>

      {/* Active filter chip — shown when navigated from home category */}
      {(filters.category || filters.subCategory) && (
        <div style={{ display:'flex', gap:6, padding:'8px 14px', background:'white', borderBottom:'1px solid #f0f0f0', flexWrap:'wrap', alignItems:'center' }}>
          <span style={{ fontSize:12, color:'#6B7280' }}>Showing:</span>
          {filters.category && (
            <span style={{ display:'inline-flex', alignItems:'center', gap:4, padding:'3px 10px', borderRadius:20, background:'#E8F5EE', color:'#1A6B3C', fontSize:12, fontWeight:600 }}>
              {filters.category.charAt(0).toUpperCase()+filters.category.slice(1)}
              <button onClick={() => setFilters(p=>({...p,category:'',subCategory:''}))} style={{ background:'none',border:'none',cursor:'pointer',color:'#1A6B3C',fontSize:14,lineHeight:1,padding:0 }}>×</button>
            </span>
          )}
          {filters.subCategory && (
            <span style={{ display:'inline-flex', alignItems:'center', gap:4, padding:'3px 10px', borderRadius:20, background:'#DCFCE7', color:'#166534', fontSize:12, fontWeight:600 }}>
              {filters.subCategory}
              <button onClick={() => setF('subCategory','')} style={{ background:'none',border:'none',cursor:'pointer',color:'#166534',fontSize:14,lineHeight:1,padding:0 }}>×</button>
            </span>
          )}
          <button onClick={() => setFilters(p=>({...p,category:'',subCategory:''}))} style={{ fontSize:11, color:'#DC2626', background:'none', border:'none', cursor:'pointer', marginLeft:'auto' }}>Show all ×</button>
        </div>
      )}

      <div style={{ maxWidth:480, margin:'0 auto', padding:'16px' }}>
        {loading ? (
          <div style={{ display:'flex', justifyContent:'center', padding:50 }}><div className="spinner" style={{ width:32, height:32 }} /></div>
        ) : crops.length === 0 ? (
          <div style={{ textAlign:'center', padding:50, color:'var(--gray-400)' }}>
            <div style={{ fontSize:48, marginBottom:10 }}>🛒</div>
            <p style={{ fontSize:15, fontWeight:500 }}>No crops available</p>
            <p style={{ fontSize:13, marginTop:4 }}>Try different filters or check back later</p>
          </div>
        ) : (
          <>
            {crops.map(crop => <CropCard key={crop._id} crop={crop} />)}
            {hasMore && (
              <button className="btn btn-gray w-full" style={{ marginTop:4 }} onClick={() => load(page+1)} disabled={loadingMore}>
                {loadingMore ? <span className="spinner" style={{ width:18, height:18 }} /> : 'Load more'}
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
